let filters = (function( $ ) {

	let $filters;

	let _init = function() {
		$filters = $( '.crate-filters' );

		if ( $filters.length > 0 ) {
			$filters.find( '.filter-group-heading' ).on( 'click', _toggle_filter_group );
			$filters.find( 'a.clear' ).on( 'click', _clear_section );
			$filters.find( ':input' ).on( 'change', _submit_form );
		}
	};

	let _clear_section = function( e ) {
		let $anchor = $( this );

		$anchor.closest( 'ul' ).find( 'input[type="checkbox"]:checked' ).prop( 'checked', false );

		submit();

		e.preventDefault();
	};

	let _toggle_filter_group = function( e ) {
		let $filter_group = $( this ).closest( '.filter-group' );

		if ( $filter_group.hasClass( 'open' ) ) {
			$filter_group.removeClass( 'open' );
			$filter_group.find( '.filter-group-items' ).slideUp();
		} else {
			$filter_group.addClass( 'open' );
			$filter_group.find( '.filter-group-items' ).slideDown();
		}

		e.preventDefault();
	};

	let _submit_form = function( e ) {
		let $filter = $( this );
		let checked = $filter.is( ':checked' );

		if ( $filter.hasClass( 'all' ) ) {
			$filter.closest( 'li' ).nextAll( 'li' ).find( 'input' ).prop( 'checked', checked );
			_submit_form();
			return;
		} else {
			let $ul = $filter.closest( 'ul' );
			let $checked_boxes = $ul.find( 'input:checked' ).not( '.all' );
			let $all_boxes     = $ul.find( 'input' ).not( '.all' );

			let all_checked = $checked_boxes.length === $all_boxes.length;

			$ul.find( 'input.all' ).prop( 'checked', all_checked );
		}

		submit();
	};

	let submit = function() {
		let base_url = $filters.data( 'base-url' );

		window.location = base_url + _generate_search_str();
	};

	let _generate_search_str = function() {
		let query = {};
		let form_data = $filters.find( 'form' ).serializeArray();

		$.each( form_data, function( index, value ) {
			if ( 'all' === value.value ) {
				// Works like "continue"
				return true;
			}

			if ( query[ value.name ] ) {
				query[ value.name ] += ',' + value.value;
			} else {
				query[ value.name ] = value.value;
			}
		} );

		return decodeURIComponent( URI( '' ).query( query ).toString() );
	};

	$( document ).ready( _init );

	return {
		submit: submit
	};

})( jQuery );

module.exports = filters;